import {Logger} from 'neo-common';
import {GameDataLoaded, IPlatforms} from './IPlatforms';
import {Platforms} from './Platforms';

export class PlatformGel implements IPlatforms {

    public create(): void {
        Platforms.canPlay = true;
        Platforms.handleFullscreen = true;

        if (DEBUG) {
            this.log('create');
        }

        window.addEventListener('message', this.receiveMessage.bind(this));
    }

    public loadProgress(progress: number): void {}

    public gameReady(): void {
        if (DEBUG) {
            this.log('gameReady');
        }

        if (Platforms.gameOrigin != null && Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.loaded',
                'data': {
                    'gameOrigin': Platforms.gameOrigin
                }
            }, Platforms.pluginOrigin);
        }
    }

    public gameFailed(): void {}

    public gameClosing(): void {
        if (DEBUG) {
            this.log('gameClosing');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.end'
            }, Platforms.pluginOrigin);
        }
    }

    public gameReloading(): void {}

    public gameChange(gameCode: string): void {}

    public error(code: string, message: string): void {}

    public clientError(id: string, message: string): void {}

    public roundInit(): void {}

    public roundStarted(): void {
        if (DEBUG) {
            this.log('roundStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.round.started'
            }, Platforms.pluginOrigin);
        }
    }

    public spinStarted(): void {
        if (DEBUG) {
            this.log('spinStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.spin.started'
            }, Platforms.pluginOrigin);
        }
    }

    public spinReceived(): void {}

    public spinEnded(): void {
        if (DEBUG) {
            this.log('spinEnded');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.spin.ended'
            }, Platforms.pluginOrigin);
        }
    }

    public roundEnded(): void {
        if (DEBUG) {
            this.log('roundEnded');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.round.ended'
            }, Platforms.pluginOrigin);
        }
    }

    public featureStarted(): void {}

    public featureInit(): void {}

    public featureFinished(): void {}

    public autoplayStarted(): void {}

    public autoplayFinished(): void {}

    public gotoCasier(): void {
        if (DEBUG) {
            this.log('gotoCasier');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.goto.cashier'
            }, Platforms.pluginOrigin);
        }
    }

    public gotoHistory(): void {
        if (DEBUG) {
            this.log('gotoHistory');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.goto.history'
            }, Platforms.pluginOrigin);
        }
    }

    public gotoHelp(): void {}

    public gotoPaytable(): void {}

    public balanceUpdated(): void {}

    public sendPluginMessage(message: string): void {
        if (DEBUG) {
            this.log('sendPluginMessage');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.handleWalletMessage', 'data': {'message': message}
            }, Platforms.pluginOrigin);
        }
    }

    public setVolume(level: number): void {}

    public quickSpinEnabled(enabled: boolean): void {}

    public bet(value: number): void {}

    public win(value: number): void {}

    public userAction(action: string, data: Object): void {}

    public gameDataLoaded(args: GameDataLoaded): void {}

    public dialogOpened(type: string, isOpen: boolean): void {}

    public fullscreen(enabled: boolean): void {}

    private receiveMessage(event: any): void {
        if (DEBUG) {
            this.log('receiveMessage');
        }

        if (event != null && event.data != null) {
            if (event.data.method != null) {
                switch (event.data.method) {
                    case 'gel.autoPlay.stop':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.stopAutoplay();
                        }
                        break;
                    case 'gel.gamePlay.stop':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayStop();
                        }
                        break;
                    case 'gel.gamePlay.resume':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayResume();
                        }
                        break;
                    case 'gel.audio.enable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gameAudioEnable();
                        }
                        break;
                    case 'gel.audio.mute':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gameAudioMute();
                        }
                        break;
                    case 'gel.balance.reload':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.refreshBalance();
                        }
                        break;
                }
            }
        }
    }

    private checkOrigin(origin: string): boolean {
        if (Platforms.pluginOrigin !== '*' && origin !== Platforms.pluginOrigin) {
            return false;
        }

        return true;
    }

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('Gel', 'Gel ' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Platforms/PlatformGel.ts
 **/